import { Option } from 'react-select';
import messages from './SelectPhoneNumber.messages';
import styles from './SelectPhoneNumber.module.css';
import { FormattedMessage } from 'react-intl';

export class PhoneNumberOption extends Option {
    renderPhoneNumber() {
        const { option, instancePrefix, optionIndex } = this.props;

        return (
            <div
                data-testid="phoneNumberOption"
                className={styles.PhoneNumberOption}
                style={option.style}
                role="option"
                aria-label={option.label}
                aria-selected="true"
                onMouseDown={this.handleMouseDown}
                onMouseEnter={this.handleMouseEnter}
                onMouseMove={this.handleMouseMove}
                onTouchStart={this.handleTouchStart}
                onTouchMove={this.handleTouchMove}
                onTouchEnd={this.handleTouchEnd}
                id={instancePrefix + '-option-' + optionIndex}
                title={option.title}
            >
                {option.label}
            </div>
        );
    }

    renderAddNewPhoneNumber() {
        const { option, instancePrefix, optionIndex } = this.props;

        return (
            <div
                data-testid="phoneNumberOption"
                className={styles.PhoneNumberOption}
                onMouseDown={this.handleMouseDown}
                onMouseEnter={this.handleMouseEnter}
                onMouseMove={this.handleMouseMove}
                onTouchStart={this.handleTouchStart}
                onTouchMove={this.handleTouchMove}
                onTouchEnd={this.handleTouchEnd}
                id={instancePrefix + '-option-' + optionIndex}
                role="option"
                aria-selected="true"
                aria-label={option.label}
                title={option.title}
            >
                <FormattedMessage {...messages.addNumber} />
            </div>
        );
    }

    render() {
        const {
            option: { type }
        } = this.props;

        switch (type) {
            case 'ADD_NEW':
                return this.renderAddNewPhoneNumber();
            default:
                return this.renderPhoneNumber();
        }
    }
}
